import _ from 'lodash';
import axios from 'axios';
import configService from '@/services/configService';
import { unwrapData } from '@/services/apiEnvelope';

async function fetchAdminList() {
  const body = await axios.get(`${configService.get('apiUrl')}/dropdowns`, {}).then(r => unwrapData(r.data));
  if (Array.isArray(body)) return body;
  if (body && Array.isArray(body.rows)) return body.rows;
  if (body && Array.isArray(body.data)) return body.data;
  return [];
}

export default {
  async list() {
    return fetchAdminList();
  },

  /** Consumer: grouped options for selects (active categories/options only). */
  async getByKey({ key }) {
    const k = encodeURIComponent(String(key).trim().toLowerCase());
    return axios
      .get(`${configService.get('apiUrl')}/dropdowns/${k}`, {})
      .then(response => unwrapData(response.data));
  },

  /** Full document for admin editor (from list aggregate). */
  async getAdminByKey({ key }) {
    const rows = await fetchAdminList();
    const k = String(key).trim().toLowerCase();
    const found = rows.find(d => String(d.key).toLowerCase() === k);
    if (!found) {
      const err = new Error('Dropdown not found');
      err.response = { data: { status: 404, message: 'Dropdown not found' } };
      throw err;
    }
    return found;
  },

  async postOne({ payload }) {
    return axios
      .post(`${configService.get('apiUrl')}/dropdowns`, payload)
      .then(response => unwrapData(response.data));
  },

  async patchOne({ key, payload }) {
    const k = encodeURIComponent(String(key).trim().toLowerCase());
    return axios
      .patch(`${configService.get('apiUrl')}/dropdowns/${k}`, _.omit(payload, ['originalKey']))
      .then(response => unwrapData(response.data));
  },

  async deleteOne({ key }) {
    const k = encodeURIComponent(String(key).trim().toLowerCase());
    return axios.delete(`${configService.get('apiUrl')}/dropdowns/${k}`).then(response => unwrapData(response.data));
  }
};
